import { inRange } from 'utils/inRange';

import styles from './styles.module.scss';
import { Props } from './types';

const InputRangeButton = ({
  amountOfButtons,
  minValue,
  maxValue,
  maxValueKey,
  minValueKey,
  handleChange,
}: Props) => {
  const maxSelectedNumber = parseInt(maxValue);
  const minSelectedNumber = parseInt(minValue);

  const handleRangeChange = (value: string) => {
    const intValue = parseInt(value);

    if (!minSelectedNumber && !maxSelectedNumber) {
      handleChange(minValueKey, value);
      handleChange(maxValueKey, value);
      return;
    }

    if (
      minSelectedNumber === maxSelectedNumber &&
      minSelectedNumber === intValue
    ) {
      handleChange(minValueKey, '');
      handleChange(maxValueKey, '');
      return;
    }

    if (intValue < minSelectedNumber) {
      handleChange(minValueKey, value);
      return;
    }

    if (intValue === minSelectedNumber) {
      handleChange(minValueKey, (minSelectedNumber + 1).toString());
      return;
    }

    if (intValue > maxSelectedNumber) {
      handleChange(maxValueKey, value);
      return;
    }

    if (intValue === maxSelectedNumber) {
      handleChange(maxValueKey, (maxSelectedNumber - 1).toString());
      return;
    }

    if (intValue > minSelectedNumber && intValue < maxSelectedNumber) {
      handleChange(maxValueKey, value);
      return;
    }
  };

  return (
    <div className={styles.container}>
      {Array.from(Array(amountOfButtons).keys())
        .map(n => n + 1)
        .map(n => {
          const buttonStyles = inRange(n, minSelectedNumber, maxSelectedNumber)
            ? [styles.rangeButton, styles.selectedRangeButton]
            : [styles.rangeButton];
          return (
            <button
              key={n}
              onClick={(e: any) => {
                handleRangeChange(e.target.innerText);
              }}
              className={buttonStyles.join(' ')}
            >
              {n}
            </button>
          );
        })}
    </div>
  );
};

export default InputRangeButton;
